import {useState, useEffect} from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {Grid, Box,Typography} from '@mui/material';
import FieldView from 'core/components/layout/FieldView';
import {setCampaignSorting} from 'store/slice/ManufSlice';

export default function CampaignListTableHeader(){
  const dispatch = useDispatch();
  const {sorting} = useSelector((state) => state.manufslice.campaignDashboard);
  
  const handleColumnClick = (column) => {
  const currentSorting = sorting.column === column ? !sorting.asc : true;
    dispatch(setCampaignSorting({ column, asc: currentSorting }));     
  }
    return (
      
      <Grid container direction="row" sx={{ justifyContent: "flex-start", alignItems: "center", width: '100%', padding: 1, backgroundColor: 'primary.lighter' }}>

            {/* <HEADER - CELLS/> */}
        
                        <Grid item lg={3} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('audiencename')}> Audience Name </Typography></Grid>
                        <Grid item lg={4} xs={4} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('audienceemail')}> Audience Email </Typography></Grid>
                        <Grid item lg={3} xs={3} ><Typography variant="h5" sx={{cursor:'pointer'}} onClick={()=>handleColumnClick('templatename')}> Template  Name </Typography></Grid>

      </Grid>
      
    )
}